import { TitleObject } from './general';

export enum FileType {
  GROUP_SYNC = 'GROUP_SYNC',
  RATE_SYNC = 'RATE_SYNC',
  AGENCY_MASTER = 'AGENCY_MASTER',
  AGENT_MASTER = 'AGENT_MASTER',
  AGENCY_AGENT_MAPPING = 'AGENCY_AGENT_MAPPING',
  GROUP_REPLY = 'GROUP_REPLY',
  EDI_REPLY = 'EDI_REPLY',
  CSR_MASTER = 'CSR_MASTER',
  AGENCY_CSR_MAPPING = 'AGENCY_CSR_MAPPING',
  AGENCY_USER_MAPPING = 'AGENCY_USER_MAPPING',
  USER_MASTER = 'USER_MASTER',
  ALLIED_BROKER_APPOINTMENT = 'ALLIED_BROKER_APPOINTMENT',
  ALLIED_GA_BROKER = 'ALLIED_GA_BROKER',
  PRODUCER_SYNC = 'PRODUCER_SYNC',
}

export const FILE_TYPE_TITLES: TitleObject<FileType> = Object.freeze({
  GROUP_SYNC: 'Group Sync',
  RATE_SYNC: 'Rate Sync',
  AGENCY_MASTER: 'Agency Master',
  AGENT_MASTER: 'Agent Master',
  AGENCY_AGENT_MAPPING: 'Agency Agent Mapping',
  GROUP_REPLY: 'Group Reply',
  EDI_REPLY: 'EDI Reply',
  CSR_MASTER: 'CSR Master',
  AGENCY_CSR_MAPPING: 'Agency CSR Mapping',
  AGENCY_USER_MAPPING: 'Agency User Mapping',
  USER_MASTER: 'User Master',
  ALLIED_BROKER_APPOINTMENT: 'Allied Broker Appointment',
  ALLIED_GA_BROKER: 'Allied GA Broker',
  PRODUCER_SYNC: 'Producer Sync',
});

export enum Step {
  NEW = 'NEW',
  VALIDATING = 'VALIDATING',
  VALIDATION_ISSUES = 'VALIDATION_ISSUES',
  VALIDATION_DONE = 'VALIDATION_DONE',
  PROCESSING = 'PROCESSING',
  DONE_ISSUES = 'DONE_ISSUES',
  DONE_FULLY = 'DONE_FULLY',
}

export interface UploadFile {
  type: FileType;
  name: string;
}

export interface UploadUrls {
  [key: string]: string;
}

export interface Upload {
  id: string;
  domainId: string;
  uploadDate: string;
  uploadDateTime: string;
  step: Step;
  fileType: FileType;
  fileName: string;
  processingOutput: ProcessingOutput;
}

export interface ProcessingOutput {
  validItemsFilePath: string;
  invalidItemsFilePath: string;
  processedItemsFilePath: string;
  unprocessedItemsFilePath: string;
}
